import type { ArticleContainer } from './article-container';
import { Connection } from './connection';
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import type { CompositionContainer } from './composition-container';

import { Container } from './container';
import type { GlobalContainer } from './global-container';

export class ContainerUtils {
  public static articleContainers(container: Container): readonly ArticleContainer[] {
    return ContainerUtils.isArticleContainer(container) ? [container] : container.articleContainers;
  }

  public static articleGuids(container: Container): string[] {
    return ContainerUtils.articleContainers(container).map((articleContainer) => articleContainer.articleGUID);
  }

  public static findFirstGivingConnection(container: Container): Connection | undefined {
    const articleContainer = ContainerUtils.isArticleContainer(container) ? container : container.articleContainers[0];
    return articleContainer.connections
      .find((connection) => connection.metaElementVO instanceof ConnectionAreaVO && connection.metaElementVO.connectionSide === ConnectionAreaVO.SIDE_GIVING);
  }

  public static isArticleContainer(object: any): object is ArticleContainer {
    return (object as ArticleContainer)?.isArticleContainer;
  }

  public static isCompositionContainer(object: any): object is CompositionContainer {
    return (object as CompositionContainer)?.isCompositionContainer;
  }

  public static isGlobalContainer(object: any): object is GlobalContainer {
    return (object as GlobalContainer)?.isGlobalContainer;
  }
}
